module.exports = "/images/ca.svg";